{
  "header": "Chi tiết tài sản",
  "subtitle": "Tài sản gắn với xe tải của bạn (rơ-moóc, container, v.v.).",
  "assetType": "Loại tài sản",
  "assetTypePlaceholder": "Chọn loại tài sản",
  "assetId": "Mã tài sản (ví dụ: Số rơ-moóc)",
  "assetIdPlaceholder": "Ví dụ: Số rơ-moóc, Mã container, v.v.",
  "remove": "Xóa",
  "addAnother": "Thêm tài sản khác",
  "trailerType": "Loại rơ-moóc",
  "trailerId": "Mã rơ-moóc"
}
